import React from 'react';

import { Section } from '@gogame/components';
import { FormField } from '@gogame/form';

import { PREPAID_EXPENSE_TYPE } from 'scenes/SpendAdjustments/components/SpendAdjustmentForm/constants';

const ExpenseType = ({ isEditing }) => {
  return (
    <Section title={'Expense Type'}>
      <FormField.Checkbox
        name={PREPAID_EXPENSE_TYPE}
        padding={'0'}
        label={'Prepaid'}
        disabled={isEditing}
      />
    </Section>
  );
};

export default ExpenseType;
